import Constants from "../../../Constants.json";

function apiBase() {
  const isLocal =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  return (isLocal ? "http://127.0.0.1:8000/api" : Constants.BACKEND_SERVER_BASE_URL || "").replace(/\/$/, "");
}

async function fetchJson(path, { signal } = {}) {
  const res = await fetch(`${apiBase()}${path}`, { signal });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || err.detail || `Erreur API (${res.status})`);
  }
  return res.json();
}

export function fetchDecisions(symbol, calendarYear, opts) {
  const q = new URLSearchParams({ symbol });
  if (calendarYear != null) q.set("calendarYear", String(calendarYear));
  return fetchJson(`/capitalflow/decisions?${q}`, opts);
}

export function fetchFundamentalsDetail(symbol, opts) {
  return fetchJson(`/capitalflow/ticker/${encodeURIComponent(symbol)}/fundamentals`, opts);
}

export function fetchTimingDetail(symbol, opts) {
  return fetchJson(`/capitalflow/ticker/${encodeURIComponent(symbol)}/timing`, opts);
}

export function fetchMarketStructureDetail(symbol, calendarYear, opts) {
  const q = calendarYear != null ? `?calendarYear=${encodeURIComponent(calendarYear)}` : "";
  return fetchJson(`/capitalflow/ticker/${encodeURIComponent(symbol)}/market-structure${q}`, opts);
}

/** Option 2 : redirige vers login si non connecté, sinon vers la page cible. */
export function navigateToProtectedDetail(navigate, isLoggedIn, targetPath, loginState = {}) {
  if (!isLoggedIn) {
    navigate("/login", { state: { returnTo: targetPath, ...loginState } });
    return;
  }
  navigate(targetPath);
}

export const DETAIL_ROUTES = {
  decision: (symbol) => `/marketflow/ticker/${encodeURIComponent(symbol)}/analyse/decision`,
  fundamentals: (symbol) => `/marketflow/ticker/${encodeURIComponent(symbol)}/analyse/fondamentaux`,
  timing: (symbol) => `/marketflow/ticker/${encodeURIComponent(symbol)}/analyse/timing`,
  market: (symbol) => `/marketflow/ticker/${encodeURIComponent(symbol)}/analyse/structure`,
};
